import React, { useEffect, useState } from 'react'

import FormTitle from '../../../components/Common/FormTitle'
import Input from '../../../components/Common/Input/Input'
import SignButton from '../../../components/Common/SignButton/SignButton'
import SubTitleLogin from '../../../components/Common/SubTitleLogin'

import { validate } from '../Signup/validate'

import styles from "./style.module.css"
import { getAuth, sendPasswordResetEmail } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'

export default function ForgotPassword() {
   const [valid, setValid] = useState([]);
   const [errorMessage, setErrorMessage] = useState("")
   const nevigate = useNavigate()
   const getDatafromForm = (formData) => ({ email: formData.get("email") })

   const handleSubmit = async (e) => {
      e.preventDefault();

      const body = getDatafromForm(new FormData(e.currentTarget))

      const checkResult = validate(body)

      setValid(checkResult)

      if (checkResult.length) return;


      const auth = getAuth();
      sendPasswordResetEmail(auth, body.email)
         .then(() => {
            setErrorMessage(' The email was sent successfully')
            setTimeout(() => {
               nevigate("/")
            }, 2500)
         })
         .catch((error) => {
            setErrorMessage(error.message)
            console.log("🚀 ~ file: Layout.jsx:83 ~ Layout ~ error:", error.message)

         });
      // const { data } = await axios.post( "http://localhost:3001/api/users/register", formData);


   };
   useEffect(() => {
      if (errorMessage) {
         setTimeout(() => {
            setErrorMessage("")

         }, 2000)
      }
   }, [errorMessage])
   return (
      <form className={styles.forgot} onSubmit={handleSubmit}>
         <FormTitle content="Forgot your password?" />
         <SubTitleLogin content="Enter your email id and we will share a link to create a new password" />
         <Input
            legend="Email"
            content="Email"
            type="email"
            name="email"
            valid={!valid.includes("email")}
         />
         {errorMessage && <div style={{ display: "flex", padding: "1rem", justifyContent: "center", alignItems: "center" }}>{errorMessage}</div>}
         <span className={styles.btnHolder}>
            <SignButton content="send me email" type="submit" />
         </span>
      </form>
   )
}
